var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VModalGeneral',{ref:"modal",staticClass:"remark-send-error",attrs:{"name":"remarkSendErrorModal","title":_vm.$t('page.designing.plans.editor.errorSendForChecking')}})
}
var staticRenderFns = []

export { render, staticRenderFns }